export enum RateType {
    FREE = 'free',
    PAID = 'paid',
    DISCOUNTED = 'discounted',
}
